import { ReactNode } from 'react'
import styled from '@emotion/styled'

const V2L2CaptionedFieldContainerRoot = styled.div({
	// TODO: ensure this works optimally with ComplexElementSize
	display: 'inline-flex',
	flexDirection: 'column',
})

const CaptionContainer = styled.div({
	padding: '0.25rem 0.5rem',
})

interface V2L2CaptionedFieldContainerProps {
	children: ReactNode
	caption?: ReactNode
}

export const V2L2CaptionedFieldContainer = ({children, caption}: V2L2CaptionedFieldContainerProps) => {
	return (
		<V2L2CaptionedFieldContainerRoot>
			{children}
			{caption ? <CaptionContainer>{caption}</CaptionContainer> : null}
		</V2L2CaptionedFieldContainerRoot>
	)
}
